module.exports = __webpack_public_path__ + "img/mopi_logo.77ba6d21.png";